export default "__VITE_ASSET__C4Mmv_D___"